import { render, staticRenderFns } from "./Arrivalnotice.vue?vue&type=template&id=6edb207c&scoped=true&"
import script from "./Arrivalnotice.vue?vue&type=script&lang=js&"
export * from "./Arrivalnotice.vue?vue&type=script&lang=js&"
import style0 from "./Arrivalnotice.vue?vue&type=style&index=0&id=6edb207c&scoped=true&lang=scss&"
import style1 from "./Arrivalnotice.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb207c",
  null
  
)

export default component.exports